import { computed, unref } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

export const useMessengerStatus = conversationId => {
  const conversationGetter = useMapGetter('getConversationById');
  const inboxGetter = useMapGetter('inboxes/getInbox');
  const conversation = computed(
    () => conversationGetter.value(unref(conversationId)) || {}
  );
  const isMessenger = computed(() => {
    const inboxId = conversation.value.inbox_id ?? conversation.value.inboxId;
    return inboxGetter.value(inboxId)?.channel_type === 'Channel::FacebookPage';
  });
  return { isMessenger };
};
